import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { useState } from 'react';

import { SessionGate } from '../features/auth/session-gate';
import type { Session } from '../features/auth/session';
import { ConsentGate } from '../features/consent/consent-gate';
import { trackApiError } from '../lib/analytics';
import { reportCrash } from '../lib/crash-report';
import { ErrorBoundary } from './error-boundary';
import { AppRouter } from './router';

export function App({ session, insideTelegram }: { session: Session; insideTelegram: boolean }) {
	const [queryClient] = useState(() => {
		const onError = (error: unknown) => {
			trackApiError(error, window.location.pathname);
		};
		return new QueryClient({
			queryCache: new QueryCache({ onError }),
			mutationCache: new MutationCache({ onError }),
			defaultOptions: { queries: { refetchOnWindowFocus: false } },
		});
	});

	return (
		<ErrorBoundary
			onCrash={(error) => {
				reportCrash(session.api, error);
			}}
		>
			<QueryClientProvider client={queryClient}>
				<SessionGate session={session} insideTelegram={insideTelegram}>
					<ConsentGate>
						<AppRouter />
					</ConsentGate>
				</SessionGate>
			</QueryClientProvider>
		</ErrorBoundary>
	);
}
